module.exports = __webpack_public_path__ + "img/1508029003.14e5b595.jpg";